import { defineMessages } from '@faceup/localization'

export const messages = defineMessages('followUp.components.reportSummary.messages', [
  { id: 'title', defaultMessage: 'Summary of your case' },
  { id: 'reportId', defaultMessage: 'Case ID' },
  { id: 'status', defaultMessage: 'Status' },
  { id: 'reported', defaultMessage: 'Submitted' },
  { id: 'lastAction', defaultMessage: 'Last updated' },
  { id: 'senderIdentity', defaultMessage: 'Identity of the sender' },
  { id: 'anonymous', defaultMessage: 'Anonymous' },
  { id: 'sentInformation', defaultMessage: 'Submitted information' },
  { id: 'victimName', defaultMessage: 'Who needs help?' },
  { id: 'category', defaultMessage: 'Category' },
  { id: 'moreInfo', defaultMessage: 'More information' },
  { id: 'attachments', defaultMessage: 'Attachments' },
  { id: 'organizationalUnit', defaultMessage: 'Organizational unit' },
  { id: 'classRoom', defaultMessage: 'Class' },
] as const)
